export default __webpack_public_path__ + "static/logo-e-2-068c05bdf883fc85168824f762e12c14.png";